var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.8 9.8H3.2C2.88174 9.8 2.57652 9.67357 2.35147 9.44853C2.12643 9.22348 2 8.91826 2 8.6V3.2C2 2.88174 2.12643 2.57652 2.35147 2.35147C2.57652 2.12643 2.88174 2 3.2 2H8.6C8.91826 2 9.22348 2.12643 9.44853 2.35147C9.67357 2.57652 9.8 2.88174 9.8 3.2V3.8M7.4 6.2H12.8C13.4627 6.2 14 6.73726 14 7.4V12.8C14 13.4627 13.4627 14 12.8 14H7.4C6.73726 14 6.2 13.4627 6.2 12.8V7.4C6.2 6.73726 6.73726 6.2 7.4 6.2Z",
    stroke: "currentColor",
    strokeWidth: 1.02857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.7c3b0c21ab9d55e45d6e2dc505dd518c.svg";
export { ForwardRef as ReactComponent };